import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TrainsInfo } from "@core/models/trainsInfo";
import { LanguageService, TrainService } from "@core/services";

@Component({
  selector: "app-train-seat-selection",
  templateUrl: "./train-seat-selection.component.html",
  styleUrls: ["./train-seat-selection.component.scss"],
})
export class TrainSeatSelectionComponent implements OnInit {
  trainsInfo: TrainsInfo;
  showedCarriage: any;
  @Input() firstTrain: boolean = true;
  @Input() train;
  @Input() section;
  @Output() selectSeatEvent: EventEmitter<any> = new EventEmitter();
  way: string;
  constructor(
    private trainService: TrainService,
    private langService: LanguageService,
    private dialogRef: MatDialogRef<TrainSeatSelectionComponent>,
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
  }

  ngOnInit(): void {
    this.showedCarriage = this.section.seats[0].carriages[0];
    this.way = this.firstTrain ? 'outward' : 'return';
  }

  getSeatContent(row: number, column: number, deck: any) {
    const seat = deck.seats.find((s) => s.row === row && s.column === column)
    return seat || null
  }

  selectSeat(row: number, column: number, deck: any) {
    if (!this.trainsInfo?.selectedSeats) {
      this.trainsInfo.selectedSeats = { outward: [], return: [] };
    }

    if (!this.trainsInfo.selectedSeats[this.way]) {
      this.trainsInfo.selectedSeats[this.way] = [];
    }

    const selectedSeats = this.trainsInfo.selectedSeats[this.way];

    const seat = deck.seats.find(s => s.row === row && s.column === column);
    if (!seat || seat.availability === "unavailable") return;

    const sectionId = this.section.sectionId;

    const existingIndex = selectedSeats.findIndex(s => s.id === seat.id);

    if (existingIndex > -1) {
      selectedSeats.splice(existingIndex, 1);
      this.reassignPassengersBySection(sectionId);
      return;
    }

    const travellers = this.trainsInfo.searchConfig.travellers;

    const sectionSeats = selectedSeats.filter(
      s => s.sectionId === sectionId
    );

    const maxSeatsPerSection = travellers.length;

    const newSeat = {
      ...seat,
      deck: deck.name,
      sectionId: sectionId,
      carriage: this.showedCarriage.name
    };

    if (sectionSeats.length >= maxSeatsPerSection) {
      const indexToReplace = selectedSeats.findIndex(
        s => s.sectionId === sectionId
      );

      if (indexToReplace > -1) {
        newSeat.passengerId = "1";
        selectedSeats[indexToReplace] = newSeat;
      }
    } else {
      newSeat.passengerId = (sectionSeats.length + 1).toString();
      selectedSeats.push(newSeat);
    }
  }

  reassignPassengersBySection(sectionId: string) {
    const selectedSeats = this.trainsInfo.selectedSeats[this.way];

    let counter = 1;

    this.trainsInfo.selectedSeats[this.way] = selectedSeats.map(seat => {
      if (seat.sectionId !== sectionId) return seat;

      return {
        ...seat,
        passengerId: (counter++).toString()
      };
    });
  }

  isSelected(row: number, column: number, deck: any) {
    const seat = deck.seats.find(
      (s) => s.row === row && s.column === column
    );

    if (!seat) return false;

    return (
      this.trainsInfo.selectedSeats?.[this.way]?.some(
        (s) => s.id === seat.id
      ) ?? false
    );
  }

  viewCarriage(carriage: any) {
    this.showedCarriage = carriage;
  }

  getCarriageName(name: string) {
    if (this.langService.getLanguage() === 'es') {
      if (name.includes('silent carriage')) 
        return "Vagón " + name.split(' - ')[0] + " - silencioso"
      return "Vagón " + name
    } else {
      return "Wagon " + name
    }
  }

  getTotalSeats() {
    let total: number = 0;
    if (this.trainsInfo.selectedSeats && this.trainsInfo.selectedSeats[this.way].filter((s) => s.sectionId === this.section.sectionId).length > 0){
      this.trainsInfo.selectedSeats[this.way].filter((s) => s.sectionId === this.section.sectionId).map((s) => {
        if(s.passengersPrice.every((p) => p.price === s.passengersPrice[0].price)){
          total += s.passengersPrice[0]?.price
        }
      })
    }
    return total;
  }

  confirmSeats() {
    this.dialogRef.close(this.trainsInfo.selectedSeats);
  }

  showSeatText(way) {
    return this.trainsInfo.selectedSeats && this.trainsInfo.selectedSeats[way] && this.trainsInfo.selectedSeats[way].length > 0 && this.trainsInfo.selectedSeats[way].find((s) => s.sectionId === this.section.sectionId)
  }

  getSeatText(seat) {
    if (this.langService.getLanguage() === 'es') {
      if (seat.carriage.includes('silent carriage')) {
        return "Vagón " + seat.carriage.split(" - silent carriage")[0] + " - silencioso " + ", asiento " + seat.position
      }
      return "Vagón " + seat.carriage + ", asiento " + seat.position
    } else {
      return "Wagon" + seat.carriage + ", seat " + seat.position
    }
  }

  getSectionSeats(way) {
    return this.trainsInfo.selectedSeats[way].filter((s) => s.sectionId === this.section.sectionId)
  }

  getSeat(deck: any, row: number, column: number) {
    return deck.seats.find(
      s => s.row === row && s.column === column
    );
  }
}
